export const termsAndConditions = {
  en: {
    title: "Terms and Conditions",
    intro:
      "Ardean Language Platform is not a language school or an official educational institution. It acts solely as an intermediary platform connecting independent mentors and students, primarily focusing on improving spoken English. It does not provide any official certifications, diplomas, or standardized curricula.",
    sections: [
      {
        title: "1. Nature of the Platform",
        body: 'Ardean Languages (https://ardeanlanguages.com/) operates strictly as an online marketplace and venue enabling students ("Students") to find and connect with independent mentors ("Mentors"). Ardean Languages does not teach, direct, or control the language sessions, nor does it guarantee specific educational outcomes or language proficiency levels.',
      },
      {
        title: "2. No Academic Accreditation",
        body: "Users explicitly acknowledge that the platform does not award formal certificates, academic credits, or recognized diplomas. Mentors establish their own lesson structures, conversational focus, and methods suited for conversational improvement, rather than formal administrative or institutional curricula.",
      },
      {
        title: "3. Independent Contractor Relationship",
        body: "Mentors using the platform are independent service providers and are not employees, agents, or partners of Ardean Languages. Ardean Languages is not responsible for the performance, behavior, quality, punctuality, or content delivered by the Mentors.",
      },
      {
        title: "4. User Responsibilities",
        body: "Users must be at least 18 years old or use the platform under supervision of a legal guardian. Students and Mentors are solely responsible for scheduling, technology setup, and mutual communications. Users agree to conduct themselves professionally and respectfully during all interactions.",
      },
      {
        title: "5. Limitation of Liability",
        body: "Ardean Languages shall not be held liable for any direct, indirect, incidental, or consequential damages resulting from the interaction between Mentors and Students, lesson cancellations, technical disruptions, or reliance on any conversational material shared during the sessions.",
      },
      {
        title: "6. Amendments",
        body: "Ardean Languages reserves the right to modify these Terms and Conditions at any time. Continued use of the website constitutes acceptance of the updated terms.",
      },
    ],
    lastUpdated: "Last Updated: May 2026",
    copyright: "Ardean Languages © 2026. All rights reserved.",
  },
  tr: {
    title: "Kullanım Şartları ve Koşulları",
    intro:
      "Ardean Dil Platformu bir dil kursu veya resmi bir eğitim kurumu değildir; bağımsız mentorlar ile öğrencileri buluşturan aracı bir platformdur ve öncelikli olarak İngilizce konuşma becerilerini geliştirmeyi amaçlar. Herhangi bir resmi sertifika, diploma veya standart bir müfredat sağlanmamaktadır.",
    sections: [
      {
        title: "1. Platformun Niteliği",
        body: 'Ardean Languages (https://ardeanlanguages.com/), öğrencilerin ("Öğrenciler") bağımsız mentorlarla ("Mentorlar") bağlantı kurmasını sağlayan çevrimiçi bir pazar yeri ve aracı mecradır. Ardean Languages dil seanslarını yönetmez, yönlendirmez veya denetlemez; belirli bir eğitim sonucu ya da dil yeterlilik seviyesi garanti etmez.',
      },
      {
        title: "2. Akademik Akreditasyon Yoktur",
        body: "Kullanıcılar, platformun resmi sertifika, akademik kredi veya tanınmış diploma vermediğini açıkça kabul ederler. Mentorlar, resmi idari veya kurumsal bir müfredat yerine, konuşma pratiğini geliştirmeye yönelik kendi ders yapılarını, sohbet konularını ve yöntemlerini belirlerler.",
      },
      {
        title: "3. Bağımsız Yüklenici İlişkisi",
        body: "Platformu kullanan Mentorlar bağımsız hizmet sağlayıcılar olup Ardean Languages'ın çalışanı, acentesi veya ortağı değillerdir. Ardean Languages, Mentorların performansı, davranışları, kalitesi, dakikliği veya sundukları içerikten sorumlu tutulamaz.",
      },
      {
        title: "4. Kullanıcı Sorumlulukları",
        body: "Kullanıcılar en az 18 yaşında olmalı veya platformu bir veli/vasi gözetiminde kullanmalıdır. Öğrenciler ve Mentorlar; planlama, teknik altyapı kurulumu ve karşılıklı iletişimden tamamen kendileri sorumludur. Kullanıcılar, tüm etkileşimler sırasında profesyonel ve saygılı bir tutum sergilemeyi kabul ederler.",
      },
      {
        title: "5. Sorumluluğun Sınırlandırılması",
        body: "Ardean Languages; Mentorlar ile Öğrenciler arasındaki etkileşimlerden, ders iptallerinden, teknik aksaklıklardan veya seanslar sırasında paylaşılan herhangi bir sohbet materyaline güvenilmesinden doğabilecek doğrudan, dolaylı veya arızi hiçbir zarardan sorumlu tutulamaz.",
      },
      {
        title: "6. Değişiklikler",
        body: "Ardean Languages, bu Kullanım Şartları ve Koşullarını dilediği zaman değiştirme hakkını saklı tutar. Web sitesinin kullanımına devam edilmesi, güncellenmiş şartların kabul edildiği anlamına gelir.",
      },
    ],
    lastUpdated: "Son Güncelleme: Mayıs 2026",
    copyright: "Ardean Languages © 2026. Tüm hakları saklıdır.",
  },
};
